import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "~/components/ui";
import { PermissionKeys, routes } from "~/lib/constants";
import { findRecordWithFullAccess } from "~/lib/utils";
import { useSelector } from "~/redux/store";

const RecordAction = () => {
  const permissions = useSelector(
    (state) => state.persistedReducer.auth.permissions,
  );

  const accessibleMenuItems = MenuItems.filter((menu) =>
    findRecordWithFullAccess(permissions, menu.id),
  );

  if (accessibleMenuItems.length === 0) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="default"
          size="default"
          className="flex h-9 items-center gap-2"
        >
          <HiOutlineMenuAlt3 className="h-4 w-4 text-secondary-500" />
          <span>Record Entry</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {accessibleMenuItems
          ?.filter((menu) => findRecordWithFullAccess(permissions, menu?.id))
          .map((item, index) => (
            <NavLink to={item?.link} className="" key={index}>
              <DropdownMenuItem key={index} className="group cursor-pointer">
                {item?.name}
              </DropdownMenuItem>
            </NavLink>
          ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
const MenuItems = [
  {
    id: PermissionKeys.recordManagement.meetingRecords.add,
    name: "Meeting",
    link: `${routes.createMeeting()}`,
  },
  {
    id: PermissionKeys.recordManagement.healthRecords.add,
    name: "Health",
    link: routes.healthRecord(),
  },
  {
    id: PermissionKeys.recordManagement.environmentalRecords.add,
    name: "Environmental",
    link: `${routes.environmentalRecord()}`,
  },
  {
    id: PermissionKeys.recordManagement.manHourRecords.add,
    name: "Work Hours",
    link: `${routes.manHours()}`,
  },
];
export default RecordAction;
